// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Products_DeleteImageInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/products/delete_image
 *
 * Removes a single image from a product gallery. The controller is
 * responsible for the actual blob/local-disk deletion and for re-promoting
 * a remaining image as primary when the deleted one was primary.
 */
import { registerContract } from './validate'

export interface Products_DeleteImageInput {
so_product_image_id: number
}

registerContract('Products_DeleteImageInput', {
  so_product_image_id: { type: 'number',  required: true },
})
